import { useContext, useState } from "react";
import Layout from "../../Layouts";
import AdminContext from "../../Services/Admin";
import HomeIcon from "../../Assets/Icons/outline/home-hashtag-black.svg";
import EditIcon from "../../Assets/Icons/outline/edit-2.svg";
import TextDashboardImg from "../../Assets/Images/text-dashboard.png";
import PatternDashboardImg from "../../Assets/Images/pattern-dashboard.png";
import { Link, useNavigate } from "react-router-dom";
import Calendar from "../../Components/Calendar/Calendar";
import ProjectModal from "./ProjectModal";
import Modal from "../../Components/Modal";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Clock from "../../Components/Clock";
import Deadline from "../../Components/Deadline";

const schema = yup
	.object({
		name: yup.string().required(),
		level: yup.string().required(),
		client_name: yup.string().required(),
		deadline: yup.string().required(),
		hex_code: yup.string().required(),
		m_project_incentive_type_id: yup.string().required(),
	})
	.required();

function DashboardPage(params) {
	const { loading, addMaster, getAllMaster } = useContext(AdminContext);
	const [modal, setModal] = useState({
		show: false,
		id: "",
		type: "",
		data: {},
	});
	const navigate = useNavigate();

	const defaultValues = {
		name: "",
		description: "",
		deadline: "",
		level: "Master Project",
		client_name: "",
		t_projects_id: "",
		hex_code: "#ffffff",
		m_project_incentive_type_id: "",
	};

	const {
		register,
		handleSubmit,
		reset,
		control,
		setValue,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues,
	});

	const handleShow = (id, type, data) => {
		setModal({ show: true, id: id, type: type, data: data });
	};

	const handleClose = () => {
		reset(defaultValues);
		setModal({ show: false, id: "", type: "", data: {} });
	};

	const addAction = async (values) => {
		let response = await addMaster(`project/create`, values);
		if (!response?.message) {
			toast.success("Add Data Success");
			navigate("/project");
			handleClose();
		}
	};

	return (
		<Layout>
			<div className="flex">
				<div className="flex-auto me-10">
					<div className="rounded-full shadow-[0_4px_16px_0_rgba(0,0,0,0.3)] py-5 px-10 font-semibold text-xl mb-20">
						Dashboard
					</div>
					<div className="flex justify-between">
						<div className="w-[400px]">
							<Link to="/" className="flex items-center">
								<img src={HomeIcon} alt="" className="w-[40px] h-[40px] me-5" />
								<div className="font-semibold text-xl pt-2">Home</div>
							</Link>
						</div>
						<div className="text-center">
							<img src={TextDashboardImg} alt="" className="max-h-[200px] w-auto mx-auto" />
							<img src={PatternDashboardImg} alt="" className="max-h-[550px] w-auto mx-auto" />
						</div>
						<div className="w-[400px] text-end">
							{(localStorage.getItem("role") === "Superadmin" ||
								localStorage.getItem("role") === "Manager" ||
								localStorage.getItem("role") === "Lead Designer") && (
								<button
									onClick={() => handleShow(null, "start project")}
									type="button"
									className="p-3 shadow-[0_0_3px_2px_rgba(0,0,0,0.3)] rounded-xl"
								>
									<img src={EditIcon} alt="" className="w-[40px] h-[40px]" />
								</button>
							)}
						</div>
					</div>
				</div>
				<div className="w-[350px]">
					<Deadline type="dashboard" />
					<div className="flex items-center justify-between mb-5">
						<Clock />
					</div>
					<Calendar />
				</div>
			</div>

			<Modal
				icon={EditIcon}
				modal={modal}
				name="Add Project"
				handleClose={handleClose}
				submit={handleSubmit(addAction)}
				loading={loading}
				width="w-[800px]"
			>
				<ProjectModal register={register} errors={errors} control={control} setValue={setValue} />
			</Modal>
		</Layout>
	);
}

export default DashboardPage;
